import { render } from "./UploadManifestPage.vue?vue&type=template&id=ecdb4076&ts=true"
import script from "./UploadManifestPage.vue?vue&type=script&lang=ts"
export * from "./UploadManifestPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__